module.exports = __webpack_public_path__ + "static/img/icon-xj.075b48eb.png";